export default {
  login: {
    title: 'साइन इन',
    username: 'उपयोगकर्ता नाम',
    phone: 'फ़ोन नंबर',
    phoneCode: 'कोड',
    email: 'ईमेल',
    password: 'पासवर्ड',
    captcha: 'कैप्चा',
    loading: 'लोड हो रहा है...',
    rememberMe: 'मुझे याद रखें',
    forgotPassword: 'पासवर्ड भूल गए?',
    loginButton: 'साइन इन',
    contactUs: 'हमसे संपर्क करें？',
    noAccount: 'खाता नहीं है?',
    registerNow: 'साइन अप',
    or: 'या',
    orSignInWith: 'या इसके साथ साइन इन करें',
    methodUsername: 'उपयोगकर्ता नाम',
    methodPhone: 'फ़ोन',
    methodEmail: 'ईमेल',
    usernameRequired: 'उपयोगकर्ता नाम आवश्यक है',
    phoneRequired: 'फ़ोन नंबर आवश्यक है',
    emailRequired: 'ईमेल आवश्यक है',
    passwordRequired: 'पासवर्ड आवश्यक है',
    captchaRequired: 'कैप्चा आवश्यक है',
    resetPassword: 'पासवर्ड रीसेट करें',
    resetStep1Hint: 'सत्यापन कोड प्राप्त करने के लिए अपना फ़ोन नंबर या ईमेल दर्ज करें।',
    useEmailInstead: 'ईमेल का उपयोग करें',
    usePhoneInstead: 'फ़ोन का उपयोग करें',
    sendCode: 'कोड भेजें',
    resetStep2Hint: 'सत्यापन कोड भेज दिया गया है',
    verificationCode: 'सत्यापन कोड',
    verificationCodeRequired: 'सत्यापन कोड आवश्यक है',
    resendIn: 'पुनः भेजें',
    resendCode: 'कोड पुनः भेजें',
    verify: 'सत्यापित करें',
    resetStep3Hint: 'अपना नया पासवर्ड सेट करें।',
    newPassword: 'नया पासवर्ड',
    confirmPassword: 'पासवर्ड की पुष्टि करें',
    passwordMinLength: 'पासवर्ड कम से कम 6 वर्णों का होना चाहिए',
    confirmPasswordRequired: 'कृपया अपने पासवर्ड की पुष्टि करें',
    passwordMismatch: 'पासवर्ड मेल नहीं खाते',
    resetPasswordBtn: 'पासवर्ड रीसेट करें',
    back: 'वापस',
    // Format validation
    emailFormat: 'अमान्य ईमेल प्रारूप',
    // Toast messages
    loginSuccess: 'लॉगिन सफल',
    loginFailed: 'लॉगिन विफल',
    signInWithGoogle: 'Google+ से साइन इन करें',
    codeSent: 'सत्यापन कोड भेजा गया',
    sendCodeFailed: 'कोड भेजने में विफल',
    invalidCode: 'अमान्य सत्यापन कोड',
    resetSuccess: 'पासवर्ड सफलतापूर्वक रीसेट हुआ',
    resetFailed: 'पासवर्ड रीसेट करने में विफल'
  }
};
